import { render, staticRenderFns } from "./OrderDeleteModal.vue?vue&type=template&id=63917b62&scoped=true&"
import script from "./OrderDeleteModal.vue?vue&type=script&lang=js&"
export * from "./OrderDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63917b62",
  null
  
)

export default component.exports